import React, { useState } from 'react';
import { Modal, Button } from 'semantic-ui-react';

export const DeleteComposer = ({
  openButton,
  onConfirm,
  composer,
  spinnerActive,
  displayError
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleDelete = () => {
    onConfirm(composer, () => {
      setModalOpen(false);
    });
  };

  return (
    <Modal
      size="small"
      trigger={React.cloneElement(openButton, {
        onClick: () => setModalOpen(true),
      })}
      open={modalOpen}
      onClose={() => {
        if (!spinnerActive) {
          setModalOpen(false);
        }
      }}
    >
      <Modal.Header>
        Delete Confirmation
      </Modal.Header>

      <Modal.Content>
        <p>
          Are you sure you want to delete this composer?
        </p>

        <p>
          This will permanently delete the composer and
          their profile.
        </p>

        {displayError && (
          <p style={{ color: 'red' }}>
            There was an error deleting the composer.
            Please try again.
          </p>
        )}
      </Modal.Content>

      <Modal.Actions>
        <Button
          basic
          onClick={() => setModalOpen(false)}
          disabled={spinnerActive}
        >
          Cancel
        </Button>

        <Button
          color="red"
          loading={spinnerActive}
          disabled={spinnerActive}
          onClick={handleDelete}
        >
          Delete
        </Button>
      </Modal.Actions>
    </Modal>
  );
};



